<div *ngIf="companyLineSummary; else noInfoSection">
    <apx-chart id="companySummaryChart"
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [plotOptions]="chartOptions.plotOptions"
    [xaxis]="chartOptions.xaxis"
    [tooltip]="chartOptions.tooltip"
    [responsive]="chartOptions.responsive"
  ></apx-chart>
  <div class="warning-section">
    <span class="danger-text" *ngIf="companyLineSummary.isLineActive != null && !companyLineSummary.isLineActive">
        <fa-icon [icon]="exclamationIcon"></fa-icon>
        Línea aprobada vencida
    </span>
  </div>
  </div>
<ng-template #noInfoSection>
<span>No hay información</span>
</ng-template>